import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "wishlist"
    }}>{`Wishlist`}</h1>
    <p>{`An e-commerce wishlist is a digital shopping list where users save desired items for future purchase. It streamlines online shopping, helping customers remember and track products, making it easy to revisit and buy them. It enhances user experience, promotes efficient browsing, and supports personalized recommendations for retailers.`}</p>
    <h2 {...{
      "id": "how-to-work-wishlist-inside-chawkbazar"
    }}>{`How to work wishlist inside Chawkbazar?`}</h2>
    <p>{`In Chawkbazar-Laravel, only `}<inlineCode parentName="p">{`registered users`}</inlineCode>{` can utilize the wishlist feature.`}</p>
    <p>{`If you like any product, and if you plan to purchase it in the future, you can save it to your wishlist.`}</p>
    <p><img alt="wishlist1" src={require("./images/wishlist/wishlist1.png")} /></p>
    <p>{`In your profile's `}<inlineCode parentName="p">{`wishlist`}</inlineCode>{` menu you will get all wishlists and you can `}<inlineCode parentName="p">{`Add To Cart`}</inlineCode>{`, `}<inlineCode parentName="p">{`Remove`}</inlineCode>{`, or See Products Details from there.`}</p>
    <p><img alt="wishlist2" src={require("./images/wishlist/wishlist2.png")} /></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      